<script setup lang="ts">
import { cn } from '~/lib/utils'
import {
  ChevronsLeft, ChevronsRight, ChevronRight,
} from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

const { isSidebarExpanded, isRightPanelOpen, breadcrumbs, toggleSidebar, toggleRightPanel } = useAppLayout()
const route = useRoute()

// Derive label from route if no breadcrumbs are set
const derivedCrumbs = computed(() => {
  if (breadcrumbs.value.length > 0) return breadcrumbs.value
  const parts = route.path.split('/').filter(Boolean)
  if (parts.length === 0) return [{ label: 'Dashboard', href: '/' }]
  return parts.map((part, i) => ({
    label: part.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
    href: '/' + parts.slice(0, i + 1).join('/'),
  }))
})
</script>

<template>
  <TooltipProvider :delay-duration="300">
  <div class="h-14 px-4 flex items-center gap-1.5 border-b border-border bg-card shrink-0">

    <!-- Sidebar toggle -->
    <Button
      variant="ghost" size="auto"
      class="size-6 flex items-center justify-center hover:bg-muted transition-colors text-muted-foreground hover:text-foreground shrink-0 [&_svg]:size-3.5"
      :title="isSidebarExpanded ? 'Skjul sidebar' : 'Udvid sidebar'"
      @click="toggleSidebar"
    >
      <ChevronsLeft v-if="isSidebarExpanded" class="size-3.5" />
      <ChevronsRight v-else class="size-3.5" />
    </Button>

    <!-- Breadcrumb trail -->
    <div class="flex items-center gap-1">
      <div
        v-for="(crumb, i) in derivedCrumbs"
        :key="i"
        class="flex items-center gap-1"
      >
        <ChevronRight v-if="i > 0" class="size-3 text-muted-foreground/40 shrink-0" />
        <NuxtLink
          v-if="crumb.href"
          :to="crumb.href"
          :class="cn(
            'text-[0.781rem] tracking-tight whitespace-nowrap transition-colors no-underline',
            i === derivedCrumbs.length - 1
              ? '!text-primary font-semibold'
              : '!text-muted-foreground hover:!text-primary'
          )"
        >
          {{ crumb.label }}
        </NuxtLink>
        <span
          v-else
          :class="cn(
            'text-[0.781rem] tracking-tight whitespace-nowrap',
            i === derivedCrumbs.length - 1
              ? '!text-primary font-semibold'
              : '!text-muted-foreground'
          )"
        >
          {{ crumb.label }}
        </span>
      </div>
    </div>

    <!-- Separator between breadcrumbs and right actions -->
    <div class="h-4 w-px bg-border mx-1 shrink-0" />

    <!-- Spacer -->
    <div class="flex-1 min-w-0" />

    <!-- Right actions -->
    <div class="flex items-center gap-2 shrink-0">
    </div>
  </div>
  </TooltipProvider>
</template>
